import { AdminTransactionRow, TransactionStatus } from 'modules/admin/dashboard/types';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { formatBRL } from 'shared/utils/format';

const STATUS_TONE: Record<TransactionStatus, 'success' | 'warning' | 'danger'> = {
  pago: 'success',
  pendente: 'warning',
  estornado: 'danger',
};

interface TransactionsTableProps {
  transactions: AdminTransactionRow[];
}

export function TransactionsTable({ transactions }: TransactionsTableProps) {
  return (
    <Card className="p-0">
      <h3 className="p-5 pb-0 font-heading font-semibold text-ink">Transações recentes</h3>

      <div className="mt-4 overflow-x-auto">
        <table className="w-full min-w-[560px] text-sm">
          <thead>
            <tr className="border-t border-border/70 text-left text-xs uppercase tracking-wide text-ink-secondary">
              <th className="px-5 py-2 font-medium">Pedido</th>
              <th className="px-5 py-2 font-medium">Arena</th>
              <th className="px-5 py-2 font-medium">Valor</th>
              <th className="px-5 py-2 font-medium">Taxa (2%)</th>
              <th className="px-5 py-2 font-medium">Status</th>
              <th className="px-5 py-2 font-medium">Quando</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction) => (
              <tr key={transaction.id} className="border-t border-border/70">
                <td className="px-5 py-3 font-medium text-ink">{transaction.id}</td>
                <td className="px-5 py-3 text-ink-secondary">{transaction.arenaName}</td>
                <td className="px-5 py-3 text-ink-secondary">{formatBRL(transaction.amount)}</td>
                <td className="px-5 py-3 text-ink-secondary">{formatBRL(transaction.platformFee)}</td>
                <td className="px-5 py-3">
                  <Badge tone={STATUS_TONE[transaction.status]} className="capitalize">
                    {transaction.status}
                  </Badge>
                </td>
                <td className="px-5 py-3 text-ink-secondary">{transaction.dateLabel}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
